// import sensors from 'sa-sdk-javascript'
import Analytics, { CreateTrackInstance } from '@du/analytics-sdk'
import Cookies from 'js-cookie'
import titleOfUrlMap from './map-title'

const sensors = process.server
  ? {
      init: Function.prototype,
      registerPage: Function.prototype,
      quick: Function.prototype,
      track: Function.prototype
    }
  : require('sa-sdk-javascript')
const serverUrl =
  process.env.customEnv === 'prod'
    ? 'https://asia-east-sensors.poizon.com/sa?project=oversea'
    : 'https://sensors.poizon.com/sa?project=hdfs_importer_test'

sensors.init({
  server_url: serverUrl,
  // eslint-disable-next-line object-shorthand
  is_track_single_page: function() {
    return titleOfUrlMap()
  },
  // show_log: false,
  send_type: 'beacon',
  use_client_time: true,
  heatmap: {
    // 开启页面点击事件($WebClick)
    clickmap: 'default',
    // 开启视区停留事件($WebStay)
    scroll_notice_map: 'default'
  }
})

function getAreaLang() {
  try {
    const params = new URLSearchParams(location.search)
    const Cookies = require('js-cookie')
    const lang = Cookies.get('locale')
    const area = Cookies.get('region')
    return {
      area: params.get('area') || area,
      lang: params.get('lang') || lang
    }
  } catch {
    return {}
  }
}

const areaAndLang = getAreaLang()

sensors.registerPage({
  dw_userid: Cookies.get('duToken')?.split('|')?.[1] || '',
  region: areaAndLang.area,
  poizon_language: areaAndLang.lang
})

class SensorsTrack extends CreateTrackInstance {
  name = 'sensors' // 埋点平台的标识名称
  target = sensors // 埋点平台的实例，备用
  applyCache = true

  track(eventName, data) {
    return new Promise((resolve) => {
      sensors.track(eventName, data, () => resolve())
    })
  }

  pv() {
    // 开启页面浏览事件($pageview)
    // fix: pv 获取 最终的title值并上报
    setTimeout(() => {
      // 开启页面浏览事件($pageview)
      sensors.quick('autoTrack', titleOfUrlMap())
    }, 500)
  }
}

Analytics.use(new SensorsTrack())

export default sensors
